import { render, staticRenderFns } from "./AssociatedAccount.vue?vue&type=template&id=12c94b17&scoped=true"
import script from "./AssociatedAccount.vue?vue&type=script&lang=js"
export * from "./AssociatedAccount.vue?vue&type=script&lang=js"
import style0 from "./AssociatedAccount.vue?vue&type=style&index=0&id=12c94b17&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c94b17",
  null
  
)

export default component.exports